<template>
  <div class="beneficiary-customer-form-project-container">
    <!-- <el-dialog
      title="Update Beneficiary"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : '80%'"
      :before-close="handleClose"
      top="5vh"
    > -->
      <el-form
        :model="beneficiaryForm"
        id="beneficiaryForm"
        ref="beneficiaryForm"
        label-width="150px"
        size="small"
        :rules="beneficiaryFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >

      <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-row :gutter="50">
          <el-col  :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Beneficiary</el-divider>
            <el-form-item prop="currency" label="Currency">
                <el-select v-model="beneficiaryForm.currency">
                  <el-option  v-for="item in currency"
                      :key="item"
                      :label="item"
                      :value="item.toLowerCase()"></el-option>
                </el-select>
              </el-form-item>

            <el-form-item prop="accountnumber" label="Account number" v-if="beneficiaryForm.currency === 'gbp'">
              <el-input v-model="beneficiaryForm.accountnumber"></el-input>
            </el-form-item>

            <el-form-item prop="sortcode" label="Sortcode" v-if="beneficiaryForm.currency === 'gbp'">
              <el-input v-model="beneficiaryForm.sortcode"></el-input>
            </el-form-item>

            <el-form-item prop="iban" label="IBAN" v-if="checkGBP">
              <el-input v-model="beneficiaryForm.iban"></el-input>
            </el-form-item>

            <el-form-item prop="bic" label="BIC" v-if="checkGBP">
              <el-input v-model="beneficiaryForm.bic"></el-input>
            </el-form-item>

            <el-divider content-position="left">Company</el-divider>
            <el-form-item prop="company.name" label="Company Name">
              <el-input v-model="beneficiaryForm.company.name"></el-input>
            </el-form-item>

            <el-form-item prop="company.tradingName" label="Trading Name">
              <el-input v-model="beneficiaryForm.company.tradingName"></el-input>
            </el-form-item>

            <el-form-item prop="company.typeOfBusiness" label="Type Of Business">
              <el-input v-model="beneficiaryForm.company.typeOfBusiness"></el-input>
            </el-form-item>

            <el-form-item
              prop="company.natureofbusiness"
              label="Nature of Business"
            >
              <!-- <el-input v-model="beneficiaryForm.company.natureofbusiness"></el-input> -->
              <el-autocomplete
                class="inline-input"
                v-model="beneficiaryForm.company.natureofbusiness"
                :fetch-suggestions="querySearchNatureofbusiness"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item
              prop="company.regulateFinancial"
              label="Regulate Financial"
            >
              <el-switch
                v-model="beneficiaryForm.company.regulateFinancial"
              ></el-switch>
            </el-form-item>

            <el-form-item
              prop="company.registrationNumber"
              label="Registration Number"
            >
              <el-input
                v-model="beneficiaryForm.company.registrationNumber"
              ></el-input>
            </el-form-item>

            <!-- <el-form-item prop="approvedate" label="Approve Date">
              <el-date-picker
                v-model="beneficiaryForm.company.approvedate"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item> -->

            <el-form-item prop="company.telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="beneficiaryForm.company.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="company.webSite" label="Website">
              <el-input
                prefix-icon="el-icon-link"
                v-model="beneficiaryForm.company.webSite"
              ></el-input>
            </el-form-item>

            <el-form-item prop="company.email" label="Email Contact">
              <el-input
                prefix-icon="el-icon-message"
                v-model="beneficiaryForm.company.email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="company.addressnumber" label="Address number">
              <el-input v-model="beneficiaryForm.company.addressnumber"></el-input>
            </el-form-item>

            <el-form-item prop="company.street" label="Street">
              <el-input v-model="beneficiaryForm.company.street"></el-input>
            </el-form-item>

            <el-form-item prop="company.city" label="City">
              <el-input v-model="beneficiaryForm.company.city"></el-input>
            </el-form-item>

            <el-form-item prop="company.zipcode" label="Zipcode">
              <el-input v-model="beneficiaryForm.company.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="company.refinement" label="Refinement">
              <el-input v-model="beneficiaryForm.company.refinement"></el-input>
            </el-form-item>

            <el-form-item prop="company.region" label="Region">
              <el-input v-model="beneficiaryForm.company.region"></el-input>
            </el-form-item>

            <el-form-item prop="company.countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="beneficiaryForm.company.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectCompanyCountrycode"
                :maxlength="3"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>


          </el-col>
          <el-col  :xs="24" :sm="24" :md="12" :lg="12">

            
            <el-divider content-position="left">Trading Address</el-divider>
            
            <el-form-item prop="company.tradingAddress.addressnumber" label="Address number">
              <el-input v-model="beneficiaryForm.company.tradingAddress.addressnumber"></el-input>
            </el-form-item>

            <el-form-item prop="company.tradingAddress.street" label="Street">
              <el-input v-model="beneficiaryForm.company.tradingAddress.street"></el-input>
            </el-form-item>

            <el-form-item prop="company.tradingAddress.city" label="City">
              <el-input v-model="beneficiaryForm.company.tradingAddress.city"></el-input>
            </el-form-item>

            <el-form-item prop="company.tradingAddress.zipcode" label="Zipcode">
              <el-input v-model="beneficiaryForm.company.tradingAddress.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="company.tradingAddress.refinement" label="Refinement">
              <el-input v-model="beneficiaryForm.company.tradingAddress.refinement"></el-input>
            </el-form-item>

            <el-form-item prop="company.tradingAddress.region" label="Region">
              <el-input v-model="beneficiaryForm.company.tradingAddress.region"></el-input>
            </el-form-item>

            <el-form-item prop="company.tradingAddress.countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="beneficiaryForm.company.tradingAddress.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectTradingCountrycode"
                :maxlength="3"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>

            <el-divider content-position="left">Director</el-divider>

            <el-form-item prop="director.name" label="Director Name">
              <el-input v-model="beneficiaryForm.director.name"></el-input>
            </el-form-item>

            <el-form-item prop="director.dateOfBirth" label="Date Of Birth">
              <el-date-picker
                v-model="beneficiaryForm.director.dateOfBirth"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="director.position" label="Position">
              <el-input v-model="beneficiaryForm.director.position"></el-input>
            </el-form-item>

            <el-form-item prop="director.telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="beneficiaryForm.director.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="director.email" label="Email">
              <el-input
                prefix-icon="el-icon-message"
                v-model="beneficiaryForm.director.email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="director.pep" label="PEP">
              <el-switch
                v-model="beneficiaryForm.director.pep"
              ></el-switch>
            </el-form-item>

            <el-form-item prop="director.pepType" label="PEP Type" v-if="beneficiaryForm.director.pep">
              <el-select v-model="beneficiaryForm.director.pepType">
                <el-option
                  label="Direct"
                  value="direct"
                ></el-option>
                <el-option
                  label="Close associate"
                  value="close-associate"
                ></el-option>
                <el-option
                  label="Former pep"
                  value="former-pep"
                ></el-option>
                <el-option
                  label="Family member"
                  value="family-member"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="director.pepNotes" label="PEP Note" v-if="beneficiaryForm.director.pep">
              <el-input v-model="beneficiaryForm.director.pepNotes"></el-input>
            </el-form-item>

            <!-- <el-form-item prop="director.approvedate" label="Approve Date">
               <el-date-picker
                v-model="beneficiaryForm.director.approvedate"
                type="date"
                value-format="yyyy-MM-dd"
              >
               </el-date-picker>
            </el-form-item> -->

            <el-form-item prop="director.nationality" label="Nationality">
              <el-autocomplete
                prefix-icon="el-icon-s-flag"
                class="inline-input"
                v-model="beneficiaryForm.director.nationality"
                :fetch-suggestions="querySearchNationality"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item prop="director.identifyType" label="Identify Type">
              <el-select v-model="beneficiaryForm.director.identifyType">
                <el-option label="Passport" value="passport"></el-option>
                <el-option
                  label="Driving Licence"
                  value="driving-licence"
                ></el-option>
                <el-option
                  label="Identity Card"
                  value="identity-card"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="director.identifyNumber"
              label="Identify Number"
            >
              <el-input
                v-model="beneficiaryForm.director.identifyNumber"
              ></el-input>
            </el-form-item>

            <el-form-item
              prop="director.identifyExpire"
              label="Identify Expire"
            >
              <el-date-picker
                v-model="beneficiaryForm.director.identifyExpire"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="director.residentCountry" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="beneficiaryForm.director.residentCountry"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectDirectorCountrycode"
                :maxlength="3"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>
        <div class="dialog-footer">
            <el-button
              type="primary"
              :loading="submiting"
              @click="submitBeneficiary()"
              >Submit</el-button
            >
            <el-button @click="handleClose">Cancel</el-button>
      </div>
    <!-- </el-dialog> -->
  </div>
</template>

<script>
import  model from "./model";
import { getUtility } from "@/api/customer";
import { addBeneficiaryProject } from '@/api/beneficiary'
export default {
  props: {
    dialogShow: Boolean,
    projectUID: String
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    checkGBP(){
      return (this.beneficiaryForm.flagswiftfx === 'international' && this.beneficiaryForm.currency === 'gbp') || this.beneficiaryForm.currency != 'gbp';
    }
  },
  data(){
    return{
      submiting: false,
      errMsg: "",
      utility: {},
      beneficiaryForm: model.company(),
      beneficiaryFormRules: model.companyRule,
      currency: []
    }
  },
  methods:{
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },
    addBeneficiaryProject() {
      this.submiting = true;
      this.errMsg = "";
      addBeneficiaryProject(this.projectUID, this.beneficiaryForm).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Add Beneficiary successfully`,
              type: "success",
              duration: 2000
            });
            this.handleClose()
            this.$emit("submited", true);
          } else {
            this.errMsg =
              typeof message === "string" ? message : "Add Beneficiary Error";
          }
        }
      );
    },
    submitBeneficiary() {
     //this.$emit("on-submited", true);
        this.$refs.beneficiaryForm.validate((valid) => {
          if (valid) {
            this.addBeneficiaryProject();
            // console.log(this.beneficiaryForm)
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      
    },
    resetForm() {
      if (this.$refs.beneficiaryForm) this.$refs.beneficiaryForm.resetFields();
    },
    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_code})
      // })
      cb(results);
    },
    querySearchResidentCountry(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_name})
      // })
      cb(results);
    },
    querySearchNationality(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "nationality"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.nationality });
      });
      cb(lists);
    },
    querySearchNatureofbusiness(queryString, cb) {
      var data = this.utility.natureofbusiness;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "name"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.name });
      });
      cb(lists);
    },

    selectDirectorCountrycode(item) {
      this.beneficiaryForm.director.residentCountry = item.country_code;
    },
    selectCompanyCountrycode(item) {
      this.beneficiaryForm.company.countrycode = item.country_code;
    },
    selectTradingCountrycode(item) {
      this.beneficiaryForm.company.tradingAddress.countrycode = item.country_code;
    },
    createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    setModel(swifttype){
      this.beneficiaryForm = model.company()
      this.beneficiaryForm.flagswiftfx = swifttype
      this.currency = model.currency[swifttype]
    },
    handleClose() {
      this.$emit("closed", false);
    },
  },
  created() {
    this.resetForm()
    this.getUtility();
  }
};
</script>

<style lang="scss">
.beneficiary-customer-form-project-container {
  .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 12px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }

  .dialog-footer{
    text-align: right;
  }

}
</style>